import {ReactNode} from 'react'

/** 실패화면 failCode */
export const FailCode = {
    /** 신청서 조회 실패 (default) */
    SUBSCRIPTION_FETCH_FAIL: 'SUBSCRIPTION_FETCH_FAIL',
    /** 신청서 조회 실패 (음수 금액) */
    INVALID_ITEM_PAY_AMOUNT: 'INVALID_ITEM_PAY_AMOUNT',
    /** 신청중 실패 */
    SUBSCRIPTION_PROCESS_FAIL: 'SUBSCRIPTION_PROCESS_FAIL',
    /** 신청완료 조회 실패 */
    SUBSCRIPTION_RESULT_FETCH_FAIL: 'SUBSCRIPTION_RESULT_FETCH_FAIL',
    /** 1회차 즉시결제 요청 실패 */
    IMMEDIATE_PAYMENT_FAIL: 'IMMEDIATE_PAYMENT_FAIL',
} as const

export type FailCodeValues = Constant<typeof FailCode>

export const FailMainMessageMap: Record<FailCodeValues, ReactNode> = {
    /** 신청서 조회 실패 (default) */
    [FailCode.SUBSCRIPTION_FETCH_FAIL]: '일시적인 오류가 발생했습니다',
    /** 신청서 조회 실패 (금액 음수) */
    [FailCode.INVALID_ITEM_PAY_AMOUNT]: '일시적인 오류가 발생했습니다',
    /** 신청서 승인 실패 */
    [FailCode.SUBSCRIPTION_PROCESS_FAIL]: '일시적인 오류가 발생했습니다',
    /** 신청 성공/실패를 모르는 경우 혹은 신청 결과 조회 실패 */
    [FailCode.SUBSCRIPTION_RESULT_FETCH_FAIL]: '일시적인 오류가 발생했습니다',
    /** 1회차 즉시결제 요청 실패 */
    [FailCode.IMMEDIATE_PAYMENT_FAIL]: (
        <>
            구독은 정상적으로 신청되었으나
            <br />
            <strong>1회차 결제를 실패</strong>했습니다
        </>
    ),
}

export const FailSubMessageMap: Record<Exclude<FailCodeValues, 'IMMEDIATE_PAYMENT_FAIL'>, ReactNode[]> = {
    /** 신청서 조회 실패 (default) */
    [FailCode.SUBSCRIPTION_FETCH_FAIL]: ['신청서 조회에 실패했습니다.', '다시 신청해주세요.'],
    /** 신청서 조회 실패 (금액 음수) */
    [FailCode.INVALID_ITEM_PAY_AMOUNT]: [
        '해당 상품은 할인 금액 설정 오류로 정기구독 신청할 수 없습니다.',
        '판매자에게 문의해주세요.',
    ],
    /** 신청서 승인 실패 */
    [FailCode.SUBSCRIPTION_PROCESS_FAIL]: ['정기구독 신청을 진행할 수 없어요.', '다시 신청해주세요.'],
    /** 신청 성공/실패를 모르는 경우 혹은 신청 결과 조회 실패 */
    [FailCode.SUBSCRIPTION_RESULT_FETCH_FAIL]: ['마이쇼핑에서 신청 정보를 확인해 주세요.'],
}

export const DescriptionMap: Record<FailCodeValues, ReactNode | undefined> = {
    /** 신청서 조회 실패 (default) */
    [FailCode.SUBSCRIPTION_FETCH_FAIL]: undefined,
    /** 신청서 조회 실패 (금액 음수) */
    [FailCode.INVALID_ITEM_PAY_AMOUNT]: undefined,
    /** 신청서 승인 실패 */
    [FailCode.SUBSCRIPTION_PROCESS_FAIL]: undefined,
    /** 신청 성공/실패를 모르는 경우 혹은 신청 결과 조회 실패 */
    [FailCode.SUBSCRIPTION_RESULT_FETCH_FAIL]: undefined,
    /** 1회차 즉시결제 요청 실패 */
    [FailCode.IMMEDIATE_PAYMENT_FAIL]: (
        <>
            실패 사유가 조치되면,
            <br />
            <em>내일 오전 10시에 정상적으로 재결제 진행될 예정입니다.</em>
        </>
    ),
}
